module.exports = __webpack_public_path__ + "img/avatar0.c6448092.png";